module.exports = __webpack_public_path__ + "Simple-Line-Icons.79cf8228e15748e5a446.woff";


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/assets/fonts/Simple-Line-Icons.woff?v=2.4.0
// module id = ../../../../../src/assets/fonts/Simple-Line-Icons.woff?v=2.4.0
// module chunks = styles